import React, { useId } from 'react';
import {
  BILT_SCORE_VIEWBOX,
  BILT_SCORE_WRENCH_PATH,
  BILT_SCORE_WRENCH_TRANSFORM,
  BILT_SCORE_WRENCH_FILL_RULE,
} from './biltBrandPaths';

type BuiltLogoIconProps = {
  className?: string;
  /** @deprecated Ignored — score pip is always the diagonal open-end wrench. */
  variant?: 'default' | 'brand';
  /** Visual treatment for score rows */
  tone?: 'metal' | 'solid';
};

/**
 * Build-score wrench pip — refined geometric open-end matching the logo lean.
 * Metal tone: cool silver into brand orange tip; hairline edge for small-size clarity.
 */
export const BuiltLogoIcon: React.FC<BuiltLogoIconProps> = ({
  className = 'w-5 h-5',
  tone = 'metal',
}) => {
  const uid = useId().replace(/:/g, '');
  const gradId = `bilt-wrench-metal-${uid}`;

  return (
    <svg
      className={className}
      viewBox={BILT_SCORE_VIEWBOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      {tone === 'metal' && (
        <defs>
          <linearGradient id={gradId} x1="7" y1="21" x2="17" y2="3" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#78716c" />
            <stop offset="35%" stopColor="#fafaf9" />
            <stop offset="68%" stopColor="#d6d3d1" />
            <stop offset="100%" stopColor="#fb923c" />
          </linearGradient>
        </defs>
      )}
      <g transform={BILT_SCORE_WRENCH_TRANSFORM}>
        <path
          d={BILT_SCORE_WRENCH_PATH}
          fillRule={BILT_SCORE_WRENCH_FILL_RULE}
          clipRule={BILT_SCORE_WRENCH_FILL_RULE}
          fill={tone === 'metal' ? `url(#${gradId})` : 'currentColor'}
          stroke={tone === 'metal' ? 'rgba(255,255,255,0.22)' : 'currentColor'}
          strokeWidth={tone === 'metal' ? 0.55 : 0}
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
      </g>
    </svg>
  );
};
